export default [
  {
    path: "/app/people",
    component: () => import("../views"),
    meta: {
      title: "Educasis - Pessoas",
      requiresAuth: true,
    },
    children: [
      //----------------------------NATURAL-PERSON----------------------------
      {
        path: "natural-person",
        name: "people.natural-person",
        component: () => import("../natural-person/views/List"),
        meta: {
          permission: "view_natural_person",
        },
      },
      {
        path: "natural-person/create",
        name: "people.natural-person.create",
        component: () => import("../natural-person/views/Create"),
        meta: {
          permission: "view_natural_person",
        },
      },
      {
        path: "natural-person/show/:id",
        name: "people.natural-person.show",
        component: () => import("../natural-person/views/Show"),
        meta: {
          permission: "view_natural_person",
        },
      },
      {
        path: "natural-person/edit/:id",
        name: "people.natural-person.edit",
        component: () => import("../natural-person/views/Edit"),
        meta: {
          permission: "view_natural_person",
        },
      },

      //----------------------------LEGAL-PERSON----------------------------

      {
        path: "legal-person",
        name: "people.legal-person",
        component: () => import("../legal-person/views/List"),
        meta: {
          permission: "view_legal_person",
        },
      },
      {
        path: "legal-person/create",
        name: "people.legal-person.create",
        component: () => import("../legal-person/views/Create"),
        meta: {
          permission: "view_legal_person",
        },
      },
      {
        path: "legal-person/show/:id",
        name: "people.legal-person.show",
        component: () => import("../legal-person/views/Show"),
        meta: {
          permission: "view_legal_person",
        },
      },
      {
        path: "legal-person/edit/:id",
        name: "people.legal-person.edit",
        component: () => import("../legal-person/views/Edit"),
        meta: {
          permission: "view_legal_person",
        },
      },

      //----------------------------COLOR-RACE----------------------------
      {
        path: "color-race",
        name: "people.color-race",
        component: () => import("../type/color-race/views/List"),
        meta: {
          permission: "view_color_race",
        },
      },
      {
        path: "color-race/create",
        name: "people.color-race.create",
        component: () => import("../type/color-race/views/Create"),
        meta: {
          permission: "view_color_race",
        },
      },
      {
        path: "color-race/edit/:id",
        name: "people.color-race.edit",
        component: () => import("../type/color-race/views/Edit"),
        meta: {
          permission: "view_color_race",
        },
      },
      //----------------------------DEFICIENCY----------------------------
      {
        path: "deficiency",
        name: "people.deficiency",
        component: () => import("../type/deficiency/views/List"),
        meta: {
          permission: "view_person_deficiency",
        },
      },
      {
        path: "deficiency/create",
        name: "people.deficiency.create",
        component: () => import("../type/deficiency/views/Create"),
        meta: {
          permission: "view_person_deficiency",
        },
      },
      {
        path: "deficiency/edit/:id",
        name: "people.deficiency.edit",
        component: () => import("../type/deficiency/views/Edit"),
        meta: {
          permission: "view_person_deficiency",
        },
      },
      //----------------------------RELIGION----------------------------
      {
        path: "religion",
        name: "people.religion",
        component: () => import("../type/religion/views/List"),
        meta: {
          permission: "view_person_religion",
        },
      },
      {
        path: "religion/create",
        name: "people.religion.create",
        component: () => import("../type/religion/views/Create"),
        meta: {
          permission: "view_person_religion",
        },
      },
      {
        path: "religion/edit/:id",
        name: "people.religion.edit",
        component: () => import("../type/religion/views/Edit"),
        meta: {
          permission: "view_person_religion",
        },
      },
      //----------------------------ADDRESSING----------------------------
      {
        path: "cities",
        name: "people.addressing.cities",
        component: () => import("../addressing/city/views/List.vue"),
        meta: {
          permission: "view_city",
        },
      },
      {
        path: "cities/create",
        name: "people.addressing.cities.create",
        component: () => import("../addressing/city/views/Create.vue"),
        meta: {
          permission: "view_city",
        },
      },
      {
        path: "cities/edit/:id",
        name: "people.addressing.cities.edit",
        component: () => import("../addressing/city/views/Edit.vue"),
        meta: {
          permission: "view_city",
        },
      },
    ],
  },
];
